import React, { PropTypes, Component } from 'react';

class Notification extends Component {
  static propTypes = {
    notifications: PropTypes.array.isRequired
  }

  static defaultProps = {
    notifications: []
  }

  render() {
    return (
      <div className="col-md-3">
        <div className="notify-container">
          <div className="notification">
            <div className="notification-title">Notification</div>
            { this.props.notifications.map(function(notification) {
                return (
                  <div className="notification-content">
                    <div className="notifier-name">
                      { notification.name }<span>{ notification.time }</span></div>
                    <div>
                      { notification.message }
                    </div>
                  </div>
                  );
              }) }
          </div>
        </div>
      </div>
      );
  }
}

module.exports = Notification;


// WEBPACK FOOTER //
// ./src/components/Notification.js